// extracted by mini-css-extract-plugin
module.exports = {"container":"RnkimContent_container__2Yxo3","frame":"RnkimContent_frame__1ziQj","spin":"RnkimContent_spin__34Aul"};